/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

import React from 'react';
import { Button, Modal} from 'react-bootstrap';


export default class ModelConfirmView extends React.Component {
    constructor(props) {
        super(props);
        this.cancel = this.cancel.bind(this)
        this.confirm = this.confirm.bind(this)
    }
    
    cancel() {
        this.props.onCancel();
    }

    confirm() {
        this.props.onConfirm();
    }

    render() {
       return (
            <Modal
                show={this.props.visible}
                container={this}
                aria-labelledby="contained-modal-title"
                dialogClassName="login-modal"
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title">{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{this.props.message}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" onClick={this.cancel.bind(this)}>Cancel</Button>{' '}
                    <Button type="button"  bsStyle="danger" onClick={this.confirm.bind(this)}>Confirm</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/modalConfirmView.js